import React, { FC } from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { typeHelpers } from '@polymathnetwork/new-shared';
import { getHoverColor } from '~/styles/utils';
import { Icon } from '../Icon';

type IconProps = typeHelpers.GetProps<typeof Icon>;

export interface IconButtonProps extends IconProps {}

const Button = styled.button`
  appearance: none;
  border: none;
  padding: 0;
  background-color: transparent;
`;

const StyledIcon = styled(Icon)`
  display: block;

  &:hover {
    color: ${({ theme, color }) =>
      color && getHoverColor(get(theme, `colors.${color}`))};
  }
`;

export const IconButton: FC<IconButtonProps> = ({
  Asset,
  children,
  className,
  style,
  ...props
}) => (
  <Button type="button" className={className} style={style}>
    <StyledIcon Asset={Asset} {...props} />
    {children}
  </Button>
);
try {
    // @ts-ignore
    IconButton.displayName = "IconButton";
    // @ts-ignore
    IconButton.__docgenInfo = { "description": "", "displayName": "IconButton", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/IconButton/index.tsx#IconButton"] = { docgenInfo: IconButton.__docgenInfo, name: "IconButton", path: "src/components/IconButton/index.tsx#IconButton" };
}
catch (__react_docgen_typescript_loader_error) { }